import {Info as InfoType} from "@/types/Infos";
import {Path} from "@/types/Paths";
import {Segment} from "@/types/Segments";
import {LuTimer} from "react-icons/lu";
import {GiPathDistance} from "react-icons/gi";
import {SiCodeforces} from "react-icons/si";

export function useBuildInfo(data: Path | Segment, iconSize: number = 20): undefined | Array<InfoType> {
  if (!data) return undefined
  const {duration, length, difficulty_label, duration_unit} = data
  const infos: Array<InfoType> = []
  if (duration) {
    infos.push({
      label: 'duration',
      value: duration,
      suffix: duration_unit,
      icon: <LuTimer size={iconSize}/>
    })
  }
  if (length) {
    infos.push({
      label: 'length',
      value: length,
      suffix: 'Km',
      icon: <GiPathDistance size={iconSize}/>
    })
  }
  if (difficulty_label) {
    infos.push({
      label: 'level',
      value: difficulty_label,
      icon: <SiCodeforces size={iconSize}/>
    })
  }
  return infos
}
